<div class="display">
	@if (imageRef && !!imageRef.viewUrl) {
		<div class="preview">
			<img [attr.alt]="imageRef.name" [src]="imageRef && !!imageRef.viewUrl ? imageRef.viewUrl : null" />
		</div>
	}
	@if (!imageRef || !imageRef.viewUrl) {
		<stages-upload
			uploadIcon="ico ico-file"
			fileExtensions=".jpg, .jpeg, .gif, .png, .svg, .webp, .bmp"
			[uploadCompletedCallback]="uploadCompletedCallback"
			[uploadUrl]="uploadUrl!"
		>
		</stages-upload>
	}
</div>
@if (imageRef) {
	<div class="edit">
		<div>
			<stages-description-editor-imagemap
				[imageRef]="imageRef"
				(imageMapChanged)="onChange()"
			></stages-description-editor-imagemap>
			@if (mapValidationMessageKey) {
				<div class="validation-info">
					<span class="p2" [translate]="mapValidationMessageKey">&nbsp;</span>
				</div>
			}
		</div>
	</div>
}
